<div class="mb-4 hidden-xl" style="padding: 0px 20px 0px 20px;">
    <h1 class="mb-1 lh-1 fw-bold h5">Reset your password</h1>
    <label style="font-size: 14px;">Enter new password to access your business manager account</label>
</div>
<div class="mb-xl-0 text-center text-md-start shadow-register p-3 bg-white corner-radius responsive-noShadow">
    <div>
        <div class="card-body p-6">
            <div class="mb-4 hidden-sm" style="padding: 0px 20px 0px 20px;">
                <h1 class="lh-1 fw-bold h5">Reset your password</h1>
                <label style="font-size: 14px;">Enter new password to access your business manager account</label>
            </div>
            <form [formGroup]="passwordForm" style="padding: 0px 20px 0px 20px;" class="no-padding">
                <!-- Email -->
                <div class="mb-4 py-2">
                    <input type="password" formControlName="password" class="form-control" style="font-size: 12px;
                    line-height: 15px;
                    letter-spacing: 0.2px;
                    color: #999999;border-bottom: 1px solid #ECECEC;padding-left: 0px;"
                        placeholder="Enter new password" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                    <div class="input-style" *ngIf="submitted && f.password.errors" class="invalid-feedback">
                        <div *ngIf="f.password.errors.required">Password is required</div>
                        <div *ngIf="f.password.errors.minlength">Password needs to be atleast eight characters, one uppercase letter, one lowercase and one number</div>
                    </div>
                </div>
                <!-- Password -->
                <div class="mb-4 pb-2">
                    <input type="password" formControlName="passwordConfirmation" class="form-control"
                        placeholder="Confirm Password" style="font-size: 12px;
                        line-height: 15px;
                        letter-spacing: 0.2px;
                        color: #999999;border-bottom: 1px solid #ECECEC;padding-left: 0px;"
                        [ngClass]="{ 'is-invalid': submitted && f.passwordConfirmation.errors }" />
                    <div *ngIf="submitted && f.passwordConfirmation.errors" class="invalid-feedback">
                        <div *ngIf="f.passwordConfirmation.errors.required">Confirm Password is required</div>
                        <div *ngIf="f.passwordConfirmation.errors.mustMatch">Passwords must match</div>
                    </div>
                </div>
                <!-- Button -->
                <div class="mb-4 d-grid justify-content-center">
                    <button type="button" class="btn add btn-primary" style="font-size: 14px;" (click)="onSubmit()">Reset Password</button>
                </div>
            </form>
        </div>
    </div>
</div>